module.exports = "//static.hsappstatic.net/LoginUI/static-1.14642/img/connect.com-full-logo-color.svg"